import { CONFIG_OPTION_TOAST_ERROR } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import DropdownOption from 'components/Common/DropdownOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import { AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS, SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import 'react-json-pretty/themes/monikai.css';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import { getConfiguration, getDetailSimulatorGenerateNewsWeatherWarning, postSimulatorGenerateNewsWeatherWarning } from "../../../store/thunks";
import HighlightText from '../Components/HighlightText';
import SpinnerScreen from '../Components/SpinnerScreen';
import useNotificationAudio from './useNotification';
export interface Tag {
    id: string;
    text: string;
}

const GenerateWeatherWarningNews = () => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();
    const { playNotification } = useNotificationAudio();

    const AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS_LANG: any = AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [newsDetail, setNewsDetail] = useState<any | null>(null);
    const [isGenerating, setIsGenerating] = useState<boolean>(false);
    const [condition, setCondition] = useState<{ ai_model: string, head_prompt: string, tail_prompt: string } | null>(null);

    const NEWS_V2_LOG_STATUS: any = {
        INITIAL: 1,
        ERROR: 2,
        COMPLETED: 3,
    };
    const isIntervalRef = useRef<boolean>(false);
    let intervalId: any;

    const getDetailSimulatorGenerateNewsWeatherWarningData = async (id: string | number) => {
        try {
            if (isIntervalRef.current === false && !!intervalId) {
                clearInterval(intervalId);
                return;
            }
            const response: any = await getDetailSimulatorGenerateNewsWeatherWarning(id);
            if (response?.code === 200) {
                if ([
                    NEWS_V2_LOG_STATUS?.COMPLETED,
                    NEWS_V2_LOG_STATUS.ERROR
                ]?.includes(response?.data?.status)) {
                    isIntervalRef.current = false;
                    setIsGenerating((_prev) => false);
                    setNewsDetail((_prev: any) => (response?.data || null));
                    clearInterval(intervalId);
                    playNotification();
                }
            }
        } catch (error: any) {
            isIntervalRef.current = false;
            setIsGenerating((_prev) => false);
            setNewsDetail((_prev: any) => null);
            return error;
        }
    };

    const handleGenerating = async () => {
        try {
            setIsGenerating((_prev) => true);
            setNewsDetail((_prev: any) => null);
            const request = {
                head_prompt: condition?.head_prompt || '',
                tail_prompt: condition?.tail_prompt || '',
            };

            const response: any = await postSimulatorGenerateNewsWeatherWarning(request);
            if (response?.code === 200 && response?.data?.id) {
                isIntervalRef.current = true;
                intervalId = setInterval(() => {
                    getDetailSimulatorGenerateNewsWeatherWarningData(response?.data?.id);
                }, 20000);
                getDetailSimulatorGenerateNewsWeatherWarningData(response?.data?.id);
            } else {
                isIntervalRef.current = false;
                setIsGenerating((_prev) => false);
                toast(`${response || ""}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsGenerating((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const handleGetConfig = async () => {
        try {
            const [res1, res2]: any = await Promise.all([getConfiguration()]);
            if (res1?.code === 200 && res2?.code === 200) {
                const _configs = res1?.data?.list || [];
                const data = {
                    ai_model: AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS_LANG[0]?.value,
                    head_prompt: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.SIMULATOR_WEATHER_WARNING_NEWS_GENERATE_HEAD_PROMPT)?.value || '',
                    tail_prompt: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.SIMULATOR_WEATHER_WARNING_NEWS_GENERATE_TAIL_PROMPT)?.value || '',
                }
                setCondition((_prev: any) => ({ ..._prev, ...data }));
            }
        } catch (error) {
            return error;
        }
    };

    useEffect(() => {
        handleGetConfig();
    }, []);


    useEffect(() => {
        document.title = `${t('Simulator')} - ${t('Weather Warning News Simulator')} | PRESS Ai`;
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t('Weather Warning News Simulator')} pageTitle={t('Simulator')} />
                    <Row>
                        {isHavePermissionRole(ROLES_FOR_APP.LAB, userPermissions) && (
                            <Col lg={12}>
                                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                                    <CardHeader className="border-0">
                                        <Row className="g-4 align-items-center">
                                            <div className="col-sm-7">
                                                <div>
                                                    <h5 className="card-title mb-0">
                                                        <span>

                                                        </span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <div className="col-sm-5 text-end">

                                            </div>
                                        </Row>
                                    </CardHeader>
                                    <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                        <Row>
                                            <Col sm={6} className='mt-3 mt-md-2 mb-3'>
                                                <LabelWrapper label={t('Head Prompt')} isShow={true}>
                                                    <Input
                                                        name="text"
                                                        type="textarea"
                                                        className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                        placeholder=""
                                                        style={{ height: '200px' }}
                                                        value={condition?.head_prompt}
                                                        onChange={(event: any) => {
                                                            const input = event.target.value;
                                                            setCondition((_prev: any) => ({ ..._prev, head_prompt: input }))
                                                        }}
                                                        autoComplete="off"
                                                    />
                                                    {/* <div className="w-100 mb-1 mb-xl-0 fs-12 text-muted pt-0">{t(`{today_kst}, {published_kst}, {published_line}, {keyword_info} will replace dynamically`)}</div> */}
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={6} className='mt-3 mt-md-2 mb-3'>
                                                <LabelWrapper label={t('Tail Prompt')} isShow={true}>
                                                    <Input
                                                        name="text"
                                                        type="textarea"
                                                        className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                        placeholder=""
                                                        style={{ height: '200px' }}
                                                        value={condition?.tail_prompt}
                                                        onChange={(event: any) => {
                                                            const input = event.target.value;
                                                            setCondition((_prev: any) => ({ ..._prev, tail_prompt: input }))
                                                        }}
                                                        autoComplete="off"
                                                    />
                                                    <div className="w-100 mb-1 mb-xl-0 fs-12 text-muted pt-0">{t("{{keywords}} will replace dynamically", { keywords: `{region}, {current_date}, {current_time}, {weather_data}, {weather_warning}` })}</div>
                                                </LabelWrapper>
                                            </Col>
                                            <Col sm={12} md={12} className='mt-3 mt-md-2'>
                                                <div className='w-100 d-flex justify-content-between align-items-center gap-4'>
                                                    <div className=''>
                                                        <LabelWrapper label={t('AI Model')} isShow={true}>
                                                            <DropdownOption
                                                                name="ai_model"
                                                                dataList={AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS_LANG || []}
                                                                placeholder={`${t("AI Model")}...`}
                                                                className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                                                classNamePrefix="name-prefix"
                                                                // style={{ width: '150px' }}
                                                                initialValue={AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS_LANG?.find((item: any) => item?.value === condition?.ai_model) || AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS_LANG[0]}
                                                                onChangeSelect={(e: any) => {
                                                                    setCondition((_prev: any) => ({ ..._prev, ai_model: e?.value }))
                                                                }}
                                                            />
                                                        </LabelWrapper>
                                                    </div>
                                                    <div className='w-100 d-flex align-items-center gap-4'>
                                                        <button
                                                            className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center mb-3 mb-lg-2 mb-xxl-1"
                                                            type="button"
                                                            color="light"
                                                            onClick={handleGenerating}
                                                            disabled={!!isGenerating}
                                                            style={{ width: '160px', minWidth: '160px' }}
                                                        >
                                                            {isGenerating ? <span style={{ transform: 'translateY(1px)' }}><Spinner size="sm"></Spinner></span> : <i className="ri-refresh-line" style={{ lineHeight: '22px' }} />}
                                                            <span className="ms-1">{t("Generate News")}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <CardBody className="pt-3">
                                        <Row>
                                            <Col lg={6} className={`h-100-pc mt-2 mt-md-0 mb-3 position-relative`}>
                                                <span className="position-absolute text-success fs-13 text-end px-2" style={{
                                                    top: 0,
                                                    left: 20,
                                                    transform: `translateY(-${10}px)`,
                                                    zIndex: 10,
                                                    backgroundColor: 'var(--vz-secondary-bg)'
                                                }}>
                                                    {t('Generated News')}
                                                </span>
                                                <div className="inner-modal-body color-scrollbar-os position-relative " style={{ border: '1.5px dashed var(--vz-success)', minHeight: '65dvh', }}>
                                                    <span className="d-flex align-items-center text-success position-absolute fs-13" style={{ top: 5, right: 10 }}>
                                                        {!!newsDetail?.title}
                                                    </span>
                                                    <div className="p-2 color-scrollbar-os overflow-y-auto" style={{ height: '65dvh' }}>
                                                        {(!!isGenerating) ? <SpinnerScreen zIndex={9} isShow={true} /> : (
                                                            <>
                                                                <p className="mb-3 fs-20 mt-2" style={{ lineHeight: '170%', fontWeight: 600 }}>{newsDetail?.title}</p>
                                                                <p className="mb-3 mt-3 fs-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                                                                    <HighlightText text={newsDetail?.body || ''} keyword={newsDetail?.keyword || ''} is_highlight_date={true} />
                                                                </p>
                                                            </>)}
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={6} className={`h-100-pc mt-2 mt-md-0 mb-3 position-relative`}>
                                                <span className="position-absolute text-success fs-13 text-end px-2" style={{
                                                    top: 0,
                                                    left: 20,
                                                    transform: `translateY(-${10}px)`,
                                                    zIndex: 10,
                                                    backgroundColor: 'var(--vz-secondary-bg)'
                                                }}>
                                                    {t('Prompt News')}
                                                </span>
                                                <div className="inner-modal-body color-scrollbar-os position-relative " style={{ border: '1.5px dashed var(--vz-success)', minHeight: '65dvh' }}>
                                                    <span className="d-flex align-items-center text-success position-absolute fs-13" style={{ top: 5, right: 10 }}>
                                                        {!!newsDetail?.title}
                                                    </span>
                                                    <div className="p-2 color-scrollbar-os overflow-y-auto" style={{ height: '65dvh' }}>
                                                        {(!!isGenerating) ? <SpinnerScreen zIndex={9} isShow={true} /> : (
                                                            <>
                                                                <p className="mb-3 mt-3 fs-16" style={{ whiteSpace: 'pre-line', lineHeight: '170%' }}>
                                                                    <HighlightText text={newsDetail?.prompt || ''} keyword={newsDetail?.keyword || ''} is_highlight_date={true} />
                                                                </p>
                                                            </>)}
                                                    </div>

                                                </div>
                                            </Col>

                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        )}
                    </Row>
                </Container>
                <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
            </div >
        </React.Fragment >
    );
};

export default GenerateWeatherWarningNews;